import { css } from '@emotion/react';
import { FlexStyle } from './FlexStyles';
import { InputStyle } from './InputStyle';
import { themeOld } from './theme';

export const SelectStyle = (
	{
		sizeSmall,
		sizeMedium,
		sizeLarge,
		ghost,
		fontSize18,
		hideCarret,
		isEmpty,
	}: {
		sizeLarge?: boolean;
		sizeMedium?: boolean;
		sizeSmall?: boolean;
		ghost?: boolean;
		fontSize18?: boolean;
		hideCarret?: boolean;
		isEmpty?: boolean;
	} = {
		sizeLarge: false,
		sizeMedium: false,
		sizeSmall: false,
		ghost: false,
		fontSize18: false,
		hideCarret: false,
		isEmpty: false,
	},
) => [
	FlexStyle({ alignItemsCenter: true }),
	css`
		${InputStyle({ sizeSmall, sizeLarge, sizeMedium })};

		color: ${themeOld.COLOR_DARK_GREEN_DARKEN_6};

		white-space: nowrap;

		&:hover,
		&.open {
			cursor: pointer;
			border-color: transparent;
			box-shadow: 0 0 0 2px ${themeOld.COLOR_DARK_GREEN_LIGHTEN_65};
			transition: all 0.2s ease-in-out;
		}

		&.open {
			box-shadow: 0 0 0 2px ${themeOld.COLOR_DARK_GREEN_LIGHTEN_46};
		}

		&:focus {
			border-color: ${themeOld.COLOR_BASE_GREEN};
		}

		${!hideCarret &&
		css`
			padding-right: 36px;

			&:after {
				position: absolute;
				right: 16px;
				line-height: 0;
				height: 5px;
				overflow: hidden;
				background-position: center;
				transform: translate(0, -1px);
				color: blue;
				content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjQiIHZpZXdCb3g9IjAgMCA4IDQiPjxwb2x5Z29uIGZpbGw9IiM3RjgyOUMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgcG9pbnRzPSI0IDAgOCA0IDAgNCIgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMCA0KSIvPjwvc3ZnPg==');

				transition: all 0.16s ease-in-out;
			}
		`}

		${sizeSmall &&
		css`
			&:after {
				transform: translate(0, 0);
			}
		`}

		&.open {
			&:after {
				transform-origin: center center;
				transform: rotate(180deg);

				transition: all 0.2s ease-in-out;
			}
		}

		${ghost &&
		css`
			border: 0;

			&:hover,
			&.open {
				box-shadow: none;
				background: #f1f1f4;
			}
		`}

		${fontSize18 &&
		css`
			font-size: 18px;
			line-height: 24px;
			font-weight: 600;

			&:after {
				height: 6px;
			}
		`}

		${isEmpty &&
		css`
			color: ${themeOld.COLOR_DARK_GREEN_LIGHTEN_46};
			font-weight: 400;
		`}
	`,
];
